import React from 'react';
import { Flex } from '@acko-tech/building-blocks.ui.common';
import {
    AddonModalRow,
    AddonModalRowMain,
    AddonRowAction,
    FuelOptionsText,
    StyledBox,
} from './styles';
import type { NormalizedAddon } from '../../useFormData/types';
import { formatAddonDisplayName, formatAddonRupee } from './format';

type AddonsOptionsProps = {
    addons: NormalizedAddon[];
    selectedIds: Set<string>;
    onAdd: (addon: NormalizedAddon) => void;
    onRemove: (id: string) => void;
};

export default function AddonsOptions({
    addons,
    selectedIds,
    onAdd,
    onRemove,
}: AddonsOptionsProps): JSX.Element {
    if (!addons.length) {
        return <FuelOptionsText>No add-ons available.</FuelOptionsText>;
    }

    return (
        <Flex justifyContent="center" flexDirection="column">
            <StyledBox>
                {addons.map((item) => {
                    const isSelected = selectedIds.has(item.id);
                    return (
                        <AddonModalRow key={item.id}>
                            <AddonModalRowMain>
                                <FuelOptionsText>
                                    {formatAddonDisplayName(item.name)}
                                    {` — ${formatAddonRupee(item.price)} `}
                                </FuelOptionsText>
                                {isSelected && (
                                    <FuelOptionsText
                                        style={{
                                            marginTop: 4,
                                            fontSize: 12,
                                            color: '#5c5c6e',
                                        }}
                                    >
                                        Selected
                                    </FuelOptionsText>
                                )}
                            </AddonModalRowMain>
                            {isSelected ? (
                                <AddonRowAction
                                    type="button"
                                    data-variant="danger"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRemove(item.id);
                                    }}
                                >
                                    Remove
                                </AddonRowAction>
                            ) : (
                                <AddonRowAction
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onAdd(item);
                                    }}
                                >
                                    Add
                                </AddonRowAction>
                            )}
                        </AddonModalRow>
                    );
                })}
            </StyledBox>
        </Flex>
    );
}

export { formatAddonRupee } from './format';
export { SelectedAddonsSummary } from './selectedSummary';
